import { render, staticRenderFns } from "./LayoutAuthSidebar.vue?vue&type=template&id=51e350b8"
var script = {}
import style0 from "./LayoutAuthSidebar.vue?vue&type=style&index=0&id=51e350b8&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports